import React from "react";
import moment from "moment-timezone";
import MomentUtils from "@date-io/moment";

import { makeStyles } from "@material-ui/core/styles";

import { formatMessage, getLocale } from "lib/globalize-util";
import theme from "styles/theme";

import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ClockIcon } from "components/icons/clock";
import Label from "./label";

const styles = {
    container: {
        display: "inline-block",
        position: "relative" as "relative",
    },
    label: {
        color: theme.palette.darkGrey,
        fontWeight: 400,
        top: "2px",
        lineHeight: 1,
        fontSize: "12px",
        transform: "none",
        transformOrigin: "none",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        width: "inherit",
        position: "relative",
    },
    clockIcon: {
        position: "absolute",
        bottom: "8px",
        fontSize: "16px",
        right: "12px",
    },
};
const useStyles = makeStyles({
    root: {
        border: "1px solid " + theme.palette.lightGrey,
        borderRadius: "4px",
        height: "40px",
        "& input": {
            borderWidth: "0",
        },
        "&::after": {
            borderBottom: "none",
        },
        "&::before": {
            borderBottom: "none",
        },
        "&:hover": {
            "&::before": {
                borderBottom: "none !important",
            },
        },
    },
    icon: {
        position: "absolute",
        bottom: "8px",
        fontSize: "16px",
        right: "12px",
    },
});

interface ITimePicker {
    value: moment.Moment;
    label?: string;
    labelClassName?: string;
    onChange(value): void;
    [rest: string]: any;
}

const TimePickerComponent: React.FunctionComponent<ITimePicker> = ({
    style = {},
    label,
    labelClassName,
    value,
    onChange,
    ...rest
}) => {
    const classes = useStyles();

    return (
        <div style={Object.assign(styles.container, style)}>
            {label && <Label className={labelClassName}>{label}</Label>}
            <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment} locale={getLocale()}>
                <TimePicker
                    InputProps={{ classes: { root: classes.root } }}
                    onChange={onChange}
                    value={value}
                    ampm={getLocale() === "en"}
                    autoOk={true}
                    views={["hours", "minutes"]}
                    okLabel={formatMessage("Ok")}
                    cancelLabel={formatMessage("Cancel")}
                    {...rest}
                />
            </MuiPickersUtilsProvider>
            <ClockIcon stroke={theme.palette.darkGrey} className={classes.icon} />
        </div>
    );
};

export default TimePickerComponent;
